<template>
  <div class="frisbuy-gallery-pagination">
    <hr
      v-for="paginationItemIdx in paginationItems"
      :key="paginationItemIdx"
      @click="$emit('navigateTo', paginationItemIdx)"
      class="frisbuy-gallery-page"
      :class="{
        active: paginationItemIdx == currentItemIdx,
        'frisbuy-video-play': isPlaying,
      }"
    />
    <span class="frisbuy-gallery-pagination__counter">
      {{ currentItemIdx + 1 }}
      <span class="counter__divider"> из </span>
      {{ itemsCount }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-gallery-pagination {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;

  &__counter {
    color: #a9a9ae;
    font-size: 12px;

    min-width: fit-content;

    margin-left: 16px;
  }

  .frisbuy-gallery-page {
    width: 100%;
    height: 1px;
    border-radius: 10px;
    background-color: #131313 !important;
    opacity: 0.1;

    margin: 0;

    &:hover,
    &.active {
      opacity: 1;
    }

    &:not(.active) {
      cursor: pointer;
    }

    &.frisbuy-video-play {
      display: none;
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      /*
        IDK: why the `isPlaying` parameter?
      */
      isPlaying: false,
    };
  },

  props: {
    currentItemIdx: {
      type: Number,
      require: true,
    },

    itemsCount: {
      type: Number,
      require: true,
    },
  },

  emits: ["navigateTo"],

  computed: {
    paginationItems() {
      return Array.from(Array(this.itemsCount).keys());
    },
  },
};
</script>
